// extracted by mini-css-extract-plugin
export default {"headerWrapper":"header_headerWrapper__W4Ke+","headerContainer":"header_headerContainer__V6jNR","logo":"header_logo__UESgy","navToggleButton":"header_navToggleButton__jz7NJ"};